<div mat-dialog-content [innerHTML]="data.text | trustHtml"></div>
<div mat-dialog-actions>
    <button mat-button (click)="close()" cdkFocusInitial type="button">{{ prefixed('hint.close') | translate }}</button>
</div>
